export const ERRORS = {
  SECURITY_REQUIRED: "At least 1 security is required.",
};
